
import { useState, useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { useNavigate } from 'react-router-dom';

export default function Residential() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());

  // Disable right-click, drag, and keyboard shortcuts
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => e.preventDefault();
    const handleDragStart = (e: DragEvent) => e.preventDefault();
    const handleSelectStart = (e: Event) => e.preventDefault();
    const handleKeyDown = (e: KeyboardEvent) => {
      // Disable F12, Ctrl+Shift+I, Ctrl+U, Ctrl+S, Ctrl+Shift+C
      if (e.key === 'F12' || 
          (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'C')) ||
          (e.ctrlKey && (e.key === 'u' || e.key === 'U' || e.key === 's' || e.key === 'S'))) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const projectImages = [
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit-a.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit02.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit03.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit05.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit07.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit08.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit09.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit10.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit12.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit13.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit14.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit15.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit16.jpg",
    "https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit18.jpg"
  ];

  const handleImageLoad = (index: number) => {
    setLoadedImages(prev => new Set(prev).add(index));
  };

  return (
    <div className="min-h-screen bg-white select-none" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6">
              Residential Projects
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Crafting exceptional living spaces that combine luxury, comfort, and community.
            </p>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20" data-product-shop>
        <div className="max-w-7xl mx-auto px-6">
          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit-a.jpg',
                title: 'Summit A - Exterior View',
                description: 'Modern residential development with contemporary design'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit02.jpg',
                title: 'Summit 02 - Community Area',
                description: 'Beautifully designed community spaces for residents'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit03.jpg',
                title: 'Summit 03 - Interior Design',
                description: 'Elegant interior finishes and modern amenities'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit05.jpg',
                title: 'Summit 05 - Living Space',
                description: 'Spacious and well-appointed living areas'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit07.jpg',
                title: 'Summit 07 - Architectural Detail',
                description: 'Attention to detail in every aspect of design'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit08.jpg',
                title: 'Summit 08 - Outdoor Spaces',
                description: 'Beautiful outdoor areas and landscaping'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit09.jpg',
                title: 'Summit 09 - Building Facade',
                description: 'Modern architectural design with premium materials'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit10.jpg',
                title: 'Summit 10 - Interior Features',
                description: 'High-end finishes and thoughtful design elements'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit12.jpg',
                title: 'Summit 12 - Common Areas',
                description: 'Inviting spaces for community interaction'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit13.jpg',
                title: 'Summit 13 - Residential Units',
                description: 'Comfortable and stylish living spaces'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit14.jpg',
                title: 'Summit 14 - Development Overview',
                description: 'Comprehensive view of the residential development'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit16.jpg',
                title: 'Summit 16 - Final Phase',
                description: 'Completed development showcasing quality construction'
              },
              {
                src: 'https://images.canalrealty.us/Portfolio%20Photos/Residential/proj-r-summit18.jpg',
                title: 'Summit 18 - Landscape Design',
                description: 'Professional landscaping and outdoor amenities'
              }
            ].map((project, index) => (
              <div 
                key={index} 
                className="relative overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer group select-none"
                onClick={() => setSelectedImage(project.src)}
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              >
                <div className="w-full h-80 bg-gray-200 flex items-center justify-center relative">
                  {!loadedImages.has(index) && (
                    <div className="absolute inset-0 bg-gray-200 animate-pulse flex items-center justify-center">
                      <i className="ri-image-line text-4xl text-gray-400"></i>
                    </div>
                  )}
                  <img 
                    src={project.src}
                    alt={`Residential Project ${index + 1}`}
                    className={`w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-300 select-none pointer-events-none ${
                      loadedImages.has(index) ? 'opacity-100' : 'opacity-0'
                    }`}
                    onLoad={() => handleImageLoad(index)}
                    onContextMenu={(e) => e.preventDefault()}
                    onDragStart={(e) => e.preventDefault()}
                    draggable={false}
                    loading={index < 6 ? "eager" : "lazy"}
                    decoding="async"
                    style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none' }}
                  />
                  {/* Invisible overlay to prevent direct image interaction */}
                  <div className="absolute inset-0 bg-transparent cursor-pointer" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 select-none"
          onClick={() => setSelectedImage(null)}
          onContextMenu={(e) => e.preventDefault()}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-4xl"></i>
          </button>
          <div className="relative max-w-full max-h-full">
            <img 
              src={selectedImage}
              alt="Project Detail"
              className="max-w-full max-h-full object-contain select-none pointer-events-none"
              onClick={(e) => e.stopPropagation()}
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
              draggable={false}
              style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', maxWidth: '90vw', maxHeight: '90vh' }}
            />
            {/* Invisible overlay to prevent direct image interaction */}
            <div className="absolute inset-0 bg-transparent" onClick={(e) => e.stopPropagation()} />
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-20 bg-[#9B1F3A] text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Have a site in mind?
          </h2>
          <p className="text-xl mb-8 leading-relaxed">
            We are always on the lookout for off-market opportunities where we can bring our experience and networks to bear to create long lasting value.  Have a great opportunity? Let's get in touch.
          </p>
          <button 
            className="px-8 py-3 bg-gray-800 text-white hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer text-lg font-semibold"
            onClick={() => {
              navigate('/contact');
              window.scrollTo(0, 0);
            }}
          >
            Contact Us
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
